import React, { useEffect, useRef } from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface WindyWidgetProps {
  lat?: number;
  lon?: number;
  zoom?: number;
}

const WindyWidget: React.FC<WindyWidgetProps> = ({ 
  lat = 45.9, // Default: Monte Grappa area
  lon = 11.8,
  zoom = 10 
}) => {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // Create iframe for Windy embed
    const iframe = document.createElement('iframe');
    iframe.width = '100%';
    iframe.height = '450';
    iframe.src = `https://embed.windy.com/embed2.html?lat=${lat}&lon=${lon}&detailLat=${lat}&detailLon=${lon}&width=650&height=450&zoom=${zoom}&level=surface&overlay=wind&product=ecmwf&menu=&message=&marker=&calendar=now&pressure=&type=map&location=coordinates&detail=&metricWind=km%2Fh&metricTemp=%C2%B0C&radarRange=-1`;
    iframe.frameBorder = '0';
    iframe.style.borderRadius = '8px';
    
    // Clear container and add iframe
    containerRef.current.innerHTML = '';
    containerRef.current.appendChild(iframe);

    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
    };
  }, [lat, lon, zoom]);

  return (
    <Paper 
      elevation={3} 
      sx={{ 
        p: 3, 
        borderRadius: 2,
        background: 'linear-gradient(135deg, #f5f5f5 0%, #ffffff 100%)',
      }}
    >
      <Box 
        ref={containerRef}
        sx={{ 
          width: '100%',
          borderRadius: 2,
          overflow: 'hidden',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        }}
      />
      
      <Typography 
        variant="caption" 
        sx={{ 
          display: 'block',
          mt: 2,
          color: 'text.secondary',
          textAlign: 'center',
        }}
      >
        {t('landing.weather.poweredBy', 'Powered by Windy.com')}
      </Typography>
    </Paper>
  );
};

export default WindyWidget;